<template>

    <div id="member-nav">
        <h1>Welcome, {{ authUser.first_name }}.</h1>
        <div class="member-nav">
            <div>
                <router-link v-if="authUser.status === 1" to="/dashboard" class="base-link"><button class="submit">Dashboard</button></router-link>
                <router-link v-if="authUser.status === 1" to="/user" class="base-link"><button class="submit">Edit Profile</button></router-link>
                <router-link v-if="authUser.status === 1" to="/featuredwatches"><button class="submit">Upcoming watches </button></router-link>
            </div>
            <div>                
                <Logout  v-if="authUser.status === 1"/>
            </div>
        </div>
    </div>  

</template>

<!-- <style scope lang="scss">
    #member-nav {
        text-align: center;
       
        padding-bottom: 6px;
        margin-bottom: -105px;
        h1 {
            text-align: left;
        }
        button.submit {
            border: none;
            padding:12px;
        }
        a {
            padding:12px;
        }
        .router-link-exact-active {
            border-bottom: 6px solid #ae9248;
        }
    }

</style> -->

<script>
import { mapGetters } from "vuex";
import Logout from "../components/Logout";
import VerifyEmail from "../components/VerifyEmail";

export default {
  name: "MembersNavigation",
  components: {
    Logout,
    VerifyEmail
    },
      computed: {
    ...mapGetters("auth", ["authUser"]),
  },
}
</script>